import { useUserStore } from '@/stores'
import Turbolink from 'turbolink-ai'
import { useRouter } from 'vue-router'

interface TurboLinkInitParams {
  uid?: string
  lv?: string
  lang?: string
  loginUrl?: string
  jump?: string
  clickEventCallback?: string
}
export default function useTurboLink() {
  const userStore = useUserStore()
  const $router = useRouter()
  const initTurboLink = (data: TurboLinkInitParams) => {
    const params = {
      appKey: '6fa0aa614993a8d1657cfb005074c782',
      appSecret: 'f2c183af114d0a67079c94ea8dd6806935a35246',
      projectId: 'd4sk51vqcfqgoic12du0',
      uid:
        userStore.profile && 'id' in userStore.profile
          ? String((userStore.profile as { id?: string | number }).id ?? '')
          : '', //"<你的用户ID，非必填>"
      lv: undefined, // "<你的用户标识，非必填>",
      lang: userStore.language, // "<语言代码，非必填>",
      loginUrl: undefined, // "<用户登录页面地址（PC端不建议传入），非必填>" //1.2.3版本起：仅移动端生效，PC端使用回调方法
      jump: false, // "<归因成功是否自动打开活动，非必填>",
      clickEventCallback: undefined, // "<回调方法>"  //1.2.2版本起：玩法内监听方法点击回调，如：登录、去完成任务等（仅PC端生效）
      ...data,
    }
    // https://zwnjqc.c.allapp.link/c?l=d4skduga0mjhtcmd8edg&c=ir

    Turbolink.init(params).then((result: any) => {
      if (result.code == 200) {
        console.log('初始化成功、可调用上报方法')
      }
    })
  }
  const loadUrl = (url = 'https://zwnjqc.c.allapp.link/c?l=d4t9bo8a0mjhtcl5gplg&c=ho') => {
    const turbolinkEvenCallback = (event: any) => {
      console.log(event)
      const type = event?.type || ''
      switch (type) {
        case 'linkLoginListener':
          console.log('触发了登录')
          $router.push('/login')
          Turbolink.closeWebUrl()
          break
        case 'linkEventListener':
          console.log('触发了去完成任务')

          $router.push('/member/storage')
          Turbolink.closeWebUrl()

          console.log(event?.params)
          break
        case 'linkRedirectListener':
          console.log('回调触发（奖品去使用、长图点击、自定义组件）')
          $router.push('/member/storage')
          Turbolink.closeWebUrl()
          console.log(event?.params)
          break
        case 'linkPointsListener':
          console.log('触发了点击区域埋点')
          console.log(event?.params)
          break
        case 'linkCloseListener':
          console.log('用户主动点击关闭')
          $router.replace('/home')
          break
      }
    }
    const params = {
      url: url,
      clickEventCallback: turbolinkEvenCallback,
    }

    Turbolink.webLoadUrl(params).then((result: any) => {
      console.log(result)
    })
  }
  const loginTurboLink = async () => {
    const params = {
      uid:
        userStore.profile && 'id' in userStore.profile
          ? String((userStore.profile as { id?: string | number }).id ?? '')
          : '',
    }
    await Turbolink.login(params)
  }
  const logoutTurboLink = async () => {
    await Turbolink.logout()
  }
  return {
    initTurboLink,
    loadUrl,
    loginTurboLink,
    logoutTurboLink,
  }
}
